import EventChallengesListing from './Challenges';

export default EventChallengesListing;
